import { AuthService, AuthStatusUser } from "./auth.service";

export class AuthServiceLocal implements AuthService {
    // Implement local authentication methods here
    async localLogin(_site: string, _email: string, _password: string): Promise<void> {
        // Local login logic
        return Promise.resolve();
    }

    providerLogin(_site: string, _provider: string): void {
        //todo
    }

    async forgotPassword(_email: string, _site: string): Promise<void> {
        return Promise.resolve();
    }

    async setPassword(_token: string, _newPassword: string): Promise<void> {
        return Promise.resolve();
    }

    async checkAuthStatus(_site: string): Promise<{ isAuthenticated: boolean; user?: AuthStatusUser }> {
        // Local auth status check logic
        return Promise.resolve({ isAuthenticated: false });
    }

    async logout(_site: string): Promise<void> {
        // Local logout logic
        return Promise.resolve();
    }
    
    async changePassword(_currentPassword: string | undefined, _newPassword: string): Promise<void> {
        // Change password logic
        return Promise.resolve();
    }
}